import { render } from "./duk-print.vue?vue&type=template&id=cefa56b8&scoped=true"
import script from "./duk-print.vue?vue&type=script&lang=js"
export * from "./duk-print.vue?vue&type=script&lang=js"

import "./duk-print.vue?vue&type=style&index=0&id=cefa56b8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cefa56b8"]])

export default __exports__